import React from "react";
import { ArrowRight, BookOpen, BookMarked } from "lucide-react";
import { IMAGES, PAPERBACK_URL, KINDLE_URL } from "../site-data";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative paper-bg pt-32 pb-24 lg:pt-40 lg:pb-32 overflow-hidden"
    >
      {/* decorative rose */}
      <div
        aria-hidden
        className="absolute -top-10 -right-20 w-[520px] h-[520px] opacity-40 pointer-events-none"
        style={{
          backgroundImage: `url(${IMAGES.roses})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(1px)",
          maskImage: "radial-gradient(circle, black 40%, transparent 70%)",
          WebkitMaskImage: "radial-gradient(circle, black 40%, transparent 70%)",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 fade-up">
          <p className="eyebrow mb-6" data-testid="hero-eyebrow">
            <span className="hairline mr-3 align-middle" /> A debut collection by Nitin Sawhney
          </p>

          {/* Prominent book title */}
          <h1
            className="font-serif leading-[0.88] tracking-tight text-[#1c1a1a]"
            data-testid="hero-title"
          >
            <span className="block text-3xl sm:text-4xl lg:text-5xl font-light text-[#4a4646]">
              A Bouquet of
            </span>
            <span className="block text-[5.5rem] sm:text-[7rem] lg:text-[9rem] font-semibold text-[#8b2e3e] mt-1">
              8 Roses
            </span>
          </h1>

          <p
            className="mt-6 max-w-xl text-[#4a4646] text-lg leading-relaxed font-serif"
            data-testid="hero-tagline"
          >
             <h2
            className="font-serif text-4xl lg:text-4xl leading-tight tracking-tight text-[#1c1a1a] italic"
            data-testid="stories-title"
          >
            Stories that touch <span className="italic text-[#8b2e3e]">every heart.</span>
          </h2>
          </p>

          <p className="mt-5 max-w-xl text-[#4a4646] leading-relaxed" data-testid="hero-subtitle">
            Eight tender, hopeful tales. Small choices, lasting meaning — the quiet magic of
            everyday lives.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            <a
              href={PAPERBACK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-buy-btn"
              className="btn-rose inline-flex items-center gap-2 bg-[#8b2e3e] hover:bg-[#6d2230] text-white px-6 py-4 text-sm tracking-[0.15em] uppercase transition-colors"
            >
              <BookOpen size={16} /> Paperback · Amazon <ArrowRight size={14} />
            </a>
            <a
              href={KINDLE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-kindle-btn"
              className="inline-flex items-center gap-2 border border-[#1c1a1a] hover:bg-[#1c1a1a] hover:text-white text-[#1c1a1a] px-6 py-4 text-sm tracking-[0.15em] uppercase transition-colors"
            >
              <BookMarked size={16} /> Read on Kindle
            </a>
            <a
              href="#free-story"
              data-testid="hero-free-story-btn"
              className="inline-flex items-center gap-2 text-[#8b2e3e] underline decoration-[#e5c9c5] underline-offset-8 hover:text-[#6d2230] px-2 py-4 text-sm tracking-[0.12em] uppercase"
            >
              Read a free story
            </a>
          </div>

          <dl className="mt-14 grid grid-cols-3 gap-8 max-w-md border-t border-[#e5dcd0] pt-6">
            <div>
              <dt className="text-xs uppercase tracking-[0.2em] text-[#4a4646]">Stories</dt>
              <dd className="font-serif text-3xl text-[#1c1a1a]">08</dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-[0.2em] text-[#4a4646]">Publisher</dt>
              <dd className="font-serif text-lg text-[#1c1a1a] mt-1">Beeja House</dd>
            </div>
            <div>
              <dt className="text-xs uppercase tracking-[0.2em] text-[#4a4646]">Formats</dt>
              <dd className="font-serif text-lg text-[#1c1a1a] mt-1">Paperback · Kindle</dd>
            </div>
          </dl>
        </div>

        <div className="lg:col-span-5 flex justify-center lg:justify-end fade-up delay-2">
          <div className="relative">
            <div className="absolute -inset-4 bg-[#f4d8d8]/50 rotate-3 rounded-sm" aria-hidden />
            <img
              src={IMAGES.bookFront}
              alt="A Bouquet of 8 Roses — book cover"
              data-testid="hero-book-cover"
              className="relative w-[280px] sm:w-[340px] lg:w-[420px] book-shadow rotate-[-2deg] hover:rotate-0 transition-transform duration-700"
            />
            <div className="absolute -bottom-6 -left-8 bg-white border border-[#e5dcd0] px-5 py-3 rotate-[-4deg] shadow-md">
              <p className="eyebrow !text-[#1c1a1a]">Now Available</p>
              <p className="font-serif text-sm text-[#8b2e3e] mt-1">
                Paperback · Kindle
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
